import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "../config/api";

function PopularSearches() {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const FALLBACK_IMG = "/assets/defaultList.jpg";

    useEffect(() => {
        fetch(`${API_BASE}/api/get_popular_searches.php?limit=8`)
            .then((res) => res.json())
            .then((data) => {
                if (data.success && Array.isArray(data.data)) {
                    setItems(data.data);
                }
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    }, []);

    const goToCategory = (title) => {
        navigate(`/search?search=&location=&category=${encodeURIComponent(title)}`);
    };

    // Nothing popular yet → don't render the section at all
    if (!loading && items.length === 0) return null;

    return (
        <>
            {/* INTERNAL CSS */}
            <style>{`
        .ps-card {
          border-radius: 12px;
          overflow: hidden;
          position: relative;
          transition: transform 0.3s ease;
          cursor: pointer;
        }
        .ps-card:hover img {
          transform: scale(1.05);
        }
        .ps-img {
          width: 100%;
          height: 180px;
          object-fit: cover;
          transition: 0.4s ease;
        }
        .ps-gradient {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 70%;
          background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
        }
        .ps-text {
          position: absolute;
          bottom: 15px;
          left: 15px;
          right: 15px;
          color: #fff;
        }
        .ps-title {
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
          margin-bottom: 8px;
        }
        .ps-skel {
          height: 180px;
          border-radius: 12px;
          background: linear-gradient(90deg,#eef1f5 25%,#e2e6ea 37%,#eef1f5 63%);
          background-size: 400px 100%;
          animation: psShimmer 1.4s infinite;
        }
        @keyframes psShimmer { 0%{background-position:-200px 0} 100%{background-position:200px 0} }
      `}</style>

            <div className="container my-5">
                <h3 className="fw-bold mb-4">Popular Searches</h3>

                <div className="row g-4">
                    {loading
                        ? Array.from({ length: 8 }).map((_, i) => (
                            <div className="col-12 col-sm-6 col-lg-4 col-xl-3" key={i}>
                                <div className="ps-skel shadow-sm"></div>
                            </div>
                        ))
                        : items.map((item, i) => (
                            <div className="col-12 col-sm-6 col-lg-4 col-xl-3" key={i}>
                                <div className="ps-card shadow-sm" onClick={() => goToCategory(item.title)}>
                                    <img
                                        src={item.img || FALLBACK_IMG}
                                        className="ps-img"
                                        alt={item.title}
                                        onError={(e) => { e.target.onerror = null; e.target.src = FALLBACK_IMG; }}
                                    />
                                    <div className="ps-gradient"></div>

                                    <div className="ps-text">
                                        <div className="ps-title">{item.title}</div>
                                        <button
                                            className="btn btn-light fw-bold px-3 py-1 rounded-pill"
                                            onClick={(e) => { e.stopPropagation(); goToCategory(item.title); }}
                                        >
                                            Enquire Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </>
    );
}

export default PopularSearches;
